import { useEffect } from 'react'
import Container from '@mui/material/Container'
import HelmetMeta from '../../layouts/HelmetMeta'
import Typography from '@mui/material/Typography'
import { fadeInAnimation } from '../../utils/cssFunctions'
import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import TimelineView from '../Races/RaceViews/TimelineView.js'
import { useData, useEvents } from '../../context/DataContext'
import { useTranslation } from 'react-i18next'

export default function Events () {
  const { t } = useTranslation('events')
  const events = useEvents()
  const { loading, error, refresh } = useData()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Container sx={{ mt: 8, mb: 4 }} maxWidth='xl'>
      <HelmetMeta
        {...{
        title: t('meta.title'),
        description: t('meta.description'),
        image: '/img/races/i/ramadan-race.jpg'
      }}
      />
      {/* Page title */}
      <Typography
        component='h1'
        sx={{
          fontSize: { xs: '1.5rem', md: '2rem' },
          fontWeight: 700,
          textAlign: 'center',
          mb: 6,
          pt: 4,
          ...fadeInAnimation
        }}
      >
        {t('pageTitle')}
      </Typography>

      {error && (
        <Alert
          severity='error' sx={{ mb: 3 }} action={
            <Button color='inherit' size='small' onClick={refresh}>{t('alerts.retry')}</Button>
        }
        >
          {t('alerts.loadFailed', { error })}
        </Alert>
      )}

      {loading && (
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' }, gap: 3 }}>
          {[1, 2, 3].map(i => <Skeleton key={i} variant='rectangular' height={320} />)}
        </Box>
      )}

      {!loading && !error && (
        <Box
          sx={{
          height: '100%',
          opacity: 1,
          transition: 'opacity 300ms ease-in-out'
          // pointerEvents: cardView ? 'none' : 'auto'
        }}
        >
          <TimelineView { ...{ data: events }} isEvent />
        </Box>
      )}
    </Container>
  )
}
